module.exports = __webpack_public_path__ + "img/starkid.6f48461e.png";